import { graphql, useStaticQuery } from "gatsby"
import React from "react"
import Img from "./img"
import ReactHtmlParser from "react-html-parser"

const Content = ({ props }) => {
  const data = useStaticQuery(graphql`
    {
      allFileFile {
        edges {
          node {
            localFile {
              childImageSharp {
                gatsbyImageData(width: 256)
              }
              name
            }
            filename
          }
        }
      }
    }
  `)

  const article = props

  let article_body_elements = new ReactHtmlParser(article, {
    transform: function transform(node) {
      // match the image with filename
      if (node.type === "tag" && node.name === "img") {
        const src = node.attribs.src ? decodeURI(node.attribs.src) : ""
        const filename = src.match(/^(?:.*\/)?([^]+?|)(?=(?:\.[^.]*)?$)/)[1]
        let i = 0
        for (i = 0; filename && i < data.allFileFile.edges.length; i++) {
          if (filename === data.allFileFile.edges[i].node.localFile.name) {
            return (
              <Img
                localFile={data.allFileFile.edges[i].node.localFile}
                imageAlt={node.attribs.alt}
              />
            )
          }
        }
      }

      return undefined
    },
  })
  return <div className="parsed-content">{article_body_elements}</div>
}

export default Content
